export enum ETypeUserLabel {
  ADMINISTRADOR = 'Administrador',
  ASESOR = 'Asesor',
  NONE = ''
}

export const getTypeUserLabel = ({
  agencyName,
  isIndependentAgent,
  isBasicUser,
  isAdminAgency,
  isBrokerWithAgency
}: {
  agencyName?: string
  isIndependentAgent: boolean
  isBasicUser: boolean
  isAdminAgency: boolean
  isBrokerWithAgency: boolean
}) => {
  let agencyNameLabel: string | undefined
  let typeUserLabel = ETypeUserLabel.NONE

  if (isIndependentAgent || isAdminAgency || isBasicUser) {
    typeUserLabel = ETypeUserLabel.ADMINISTRADOR
  }

  if ((isAdminAgency || isBrokerWithAgency) && agencyName) {
    agencyNameLabel = agencyName
  }

  if (isBrokerWithAgency) {
    typeUserLabel = ETypeUserLabel.ASESOR
  }

  return {
    agencyNameLabel,
    typeUserLabel
  }
}
